/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherMaintenance
 */
export interface FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherMaintenance {
    /**
     * Причина тех работ, будет локализован
     *             
     * @type {string}
     * @memberof FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherMaintenance
     */
    ReasonText: string;
    /**
     * Причина тех работ на англ, если нет локализации
     *             
     * @type {string}
     * @memberof FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherMaintenance
     */
    ReasonTextFallback: string;
    /**
     * Время начала
     *             
     * @type {Date}
     * @memberof FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherMaintenance
     */
    DateStart?: Date | null;
    /**
     * Время окончания
     *             
     * @type {Date}
     * @memberof FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherMaintenance
     */
    DateEnd?: Date | null;
    /**
     * Принудительно закрывать запущеннкю игру
     *             
     * @type {boolean}
     * @memberof FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherMaintenance
     */
    ForceStop?: boolean | null;
    /**
     * Пока не родили нормальные роли - даем возможность отключить тут
     *             
     * @type {Array<string>}
     * @memberof FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherMaintenance
     */
    EmailsExcluded?: Array<string> | null;
}

/**
 * Check if a given object implements the FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherMaintenance interface.
 */
export function instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherMaintenance(value: object): value is FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherMaintenance {
    if (!('ReasonText' in value) || value['ReasonText'] === undefined) return false;
    if (!('ReasonTextFallback' in value) || value['ReasonTextFallback'] === undefined) return false;
    return true;
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherMaintenanceFromJSON(json: any): FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherMaintenance {
    return FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherMaintenanceFromJSONTyped(json, false);
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherMaintenanceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherMaintenance {
    if (json == null) {
        return json;
    }
    return {
        
        'ReasonText': json['ReasonText'],
        'ReasonTextFallback': json['ReasonTextFallback'],
        'DateStart': json['DateStart'] == null ? undefined : (new Date(json['DateStart'])),
        'DateEnd': json['DateEnd'] == null ? undefined : (new Date(json['DateEnd'])),
        'ForceStop': json['ForceStop'] == null ? undefined : json['ForceStop'],
        'EmailsExcluded': json['EmailsExcluded'] == null ? undefined : json['EmailsExcluded'],
    };
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherMaintenanceToJSON(json: any): FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherMaintenance {
    return FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherMaintenanceToJSONTyped(json, false);
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherMaintenanceToJSONTyped(value?: FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherMaintenance | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ReasonText': value['ReasonText'],
        'ReasonTextFallback': value['ReasonTextFallback'],
        'DateStart': value['DateStart'] == null ? undefined : ((value['DateStart'] as any).toISOString()),
        'DateEnd': value['DateEnd'] == null ? undefined : ((value['DateEnd'] as any).toISOString()),
        'ForceStop': value['ForceStop'],
        'EmailsExcluded': value['EmailsExcluded'],
    };
}

